import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { profileApi, queryClient } from '~/lib/request';
import { UpdateProfilePayload } from './types';

export function useUpdateProfile() {
  return useMutation<unknown, Error, UpdateProfilePayload>({
    mutationFn: async (data) => {
      if (data.social_links) {
        const socialMediaArray = Object.entries(data.social_links)
          .map(([platform, url]) => ({
            platform,
            url,
          }))
          .filter(({ url }) => !!url);

        await profileApi.post('api/profile/me/social-media-accounts', { json: socialMediaArray });
      }

      await profileApi.patch('api/profile/update', {
        json: {
          ...data,
          social_links: undefined,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });

      toast.success('Data updated successfully!');
    },
  });
}

export function useUpdateProfileLite() {
  return useMutation<unknown, Error, UpdateProfilePayload>({
    mutationFn: async (data) => {
      await profileApi.patch('api/profile/update', {
        json: { ...data },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });

      toast.success('Data updated successfully!');
    },
  });
}
